// extracted by mini-css-extract-plugin
export default {"question":"style_question__9oQzB","example":"style_example__yPcg0","example_title":"style_example_title__hiYIx","actions":"style_actions__rGUA-","show_more":"style_show_more__IIDA2"};